export default __webpack_public_path__ + "1820a3b94eb41cfb7e81abb5454f3c5f.png";